module.exports = __webpack_public_path__ + "static/media/header.ea9e1009.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/claims/report-view/header.png
// module id = 2077
// module chunks = 146